<div class="ourProjectsSlider" id="products">
    <div class="projectHeader">
        <p>CASE STUDIES</p>
        <h2>Our projects make us proud</h2>
    </div>
    <div class="innerCardSliderWrapper">
        <div class="container">
            <div class="row ourProjectsCardsSlider">
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="projectsCardWrapper">
                        <div class="imageSection">
                            <img src="assets/images//project1.jpg" alt="">
                        </div>
                        <div class="informationTxt">
                            <h6>liveonlinetraining.in</h6>
                            <a href="#">Edu Tech</a>
                            <p>The prospects for a company operating in this new market are varied and exciting.
                                The potential …</p>
                        </div>
                        <div class="buttonTxt">
                            <a>View case study <span><i class="fa fa-long-arrow-right"></i></span> </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="projectsCardWrapper">
                        <div class="imageSection">
                            <img src="assets/images//project2.jpg" alt="">
                        </div>
                        <div class="informationTxt">
                            <h6>Help2Consumer.com</h6>
                            <a href="#">Legal</a>
                            <p>The prospects for a company operating in this new market are varied and exciting.
                                The potential …</p>
                        </div>
                        <div class="buttonTxt">
                            <a>View case study <span><i class="fa fa-long-arrow-right"></i></span> </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="projectsCardWrapper">
                        <div class="imageSection">
                            <img src="assets/images//project3.jpg" alt="">
                        </div>
                        <div class="informationTxt">
                            <h6>CityGossiper.com</h6>
                            <a href="#">Entertainment</a>
                            <p>The prospects for a company operating in this new market are varied and exciting.
                                The potential …</p>
                        </div>
                        <div class="buttonTxt">
                            <a>View case study <span><i class="fa fa-long-arrow-right"></i></span> </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="projectsCardWrapper">
                        <div class="imageSection">
                            <img src="assets/images/project4.jpg" alt="">
                        </div>
                        <div class="informationTxt">
                            <h6>LearnPract.com</h6>
                            <a href="#">Edu Tech</a>
                            <p>The prospects for a company operating in this new market are varied and exciting.
                                The potential …</p>
                        </div>
                        <div class="buttonTxt">
                            <a>View case study <span><i class="fa fa-long-arrow-right"></i></span> </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>